import { IChannelData } from "@/entities";
import {
  BACKEND_BASE_URL,
  IGenericResponse,
  IPageRequest,
  IPageResponse,
  IResponseError,
} from "@/services";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";
import { IChannelService } from "./channel.types";

export class ChannelService implements IChannelService {
  async getChannelsPage(
    pageRequest: IPageRequest,
    text?: string,
    countryId?: number
  ): Promise<IPageResponse<IChannelData> | undefined> {
    const { response, error } = await handleResponse<IPageResponse<IChannelData>, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/channel`, {
        params: {
          ...pageRequest,
          text,
          countryId,
        },
      })
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async createChannel(
    text: string,
    countryId?: number
  ): Promise<IGenericResponse<IChannelData> | undefined> {
    const { response, error } = await handleResponse<
      IGenericResponse<IChannelData>,
      IResponseError
    >(
      Vue.$axios.post(`${BACKEND_BASE_URL}/api/configuration/v1/channel`, null, {
        params: {
          text,
          countryId,
        },
      })
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
}
